<template>
  <div class="mainBackground">
    <!-- <button @click="funcTest()">
      Test Route
    </button> -->
    <!-- <Popup :popUpIsActive="popUpIsActive" :onClosePopUp="onClosePopUp"></Popup> -->
    <template v-if="bannerImage.length <= 0">
      <CRow
        alignHorizontal="center"
        alignVertical="center"
        style="min-height: 300px; width: 100%"
      >
        <CCol col="3">
          <LoadingMDL />
        </CCol>
      </CRow>
    </template>
    <template v-else>
      <CCarousel :interval="interval" animate class="carousel-fade" indicators>
        <CCarouselItem :key="index" v-for="(item, index) in bannerImage">
          <div class="imgContainer img-fluid">
            <img :src="baseUrl + item.bannerPicture" />
          </div>
        </CCarouselItem>
      </CCarousel>
    </template>

    <!--<section class="d-inline" v-if="this.$store.getters['auth/userStatus'] && this.enrollLists != undefined">
      <inProgress
        :inProgressCourses="inProgressCourse"
        style="margin-right: 60px"
        @returndata="itemData"
        v-if="
          this.$store.getters['auth/userStatus'] && this.enrollLists.length > 0
        "
      />
    </section> -->
    <section
      class="d-inline"
      v-if="
        this.$store.getters['auth/userStatus'] &&
        this.favoriteLists != undefined
      "
    >
      <favourite
        style="margin-right: 60px"
        :favouriteCourses="this.favoriteLists"
        @returndata="itemData"
        v-if="
          this.$store.getters['auth/userStatus'] &&
          this.favoriteLists.length > 0
        "
      />
    </section>
    <section v-if="this.mfuCourse.length > 0" class="d-inline">
      <regIndex :registerCourses="this.mfuCourse" @returndata="itemData" />
    </section>

    <section
      class="d-inline"
      v-if="this.$store.getters['courses/getNewCourses'][0] != undefined"
    >
      <newIndex
        style="margin-right: 60px"
        :newCourses="completedCourse"
        @returndata="itemData"
        v-if="
          this.$store.getters['courses/getNewCourses'][0].courses.length > 0
        "
      />
    </section>

    <section
      class="d-inline"
      v-if="this.$store.getters['courses/getFreeCourses'][0] != undefined"
    >
      <freeIndex
        style="margin-right: 60px"
        :freeCourses="fetchFreeCourse()"
        @returndata="itemData"
        class="mb-5"
        v-if="
          this.$store.getters['courses/getFreeCourses'][0].courses.length > 0
        "
      />
    </section>
  </div>
</template>
<script>
import popIndex from '../components/showManyCard/popularCourses/PopIndex';
import newIndex from '../components/showManyCard/newCourses/NewIndex';
import freeIndex from '../components/showManyCard/freeCourses/FreeIndex';
import inProgress from '../components/showManyCard/inProgressCourses/InProgress';
import favourite from '../components/showManyCard/favouriteCourses/Favourite';
import regIndex from '../components/showManyCard/registeredCourses/RegisteredIndex';
import Button from '../components/signInCss/Button';
import LoadingMDL from '../components/loading/LoadingMDL';
import Popup from '../components/elements/Popup.vue';

import {mapGetters} from 'vuex';

export default {
  components: {
    Button,
    popIndex,
    newIndex,
    freeIndex,
    inProgress,
    favourite,
    regIndex,
    LoadingMDL,
    Popup,
  },
  data() {
    return {
      interval: 6000,
      favoriteLists: [],
      enrollLists: [],
      selectedCourse: {},
      bannerImage: [],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      inProgressCourse: [],
      completedCourse: [],
      mfuCourse: [],
      onlyOneLoad: 0,
      popUpIsActive: true,
    };
  },
  computed: {
    ...mapGetters({
      userCourses: 'auth/userCourses',
      getProfile: 'profile/getProfile',
      getBanners: 'getBanners',
      getMFUCourse: 'courses/getMFUCourses',
      getEnRolledCourses: 'profile/getEnRolledCourses',
    }),
  },
  watch: {
    getMFUCourse: function (val) {
      // console.log('watch call ---> getMFUCourse', val);
      this.mfuCourse = val;
    },
    getEnRolledCourses: function (val) {
      console.log('watch call ---> getEnRolledCourses', val);

      console.log(
        "this.$store.getters['auth/userStatus']",
        this.$store.getters['auth/userStatus']
      );
      console.log('this.enrollLists', this.enrollLists);

      this.onlyOneLoad += 1;
      if (this.onlyOneLoad == 1) {
        for (let i = 0; i < val.length; i++) {
          console.log('============>', val[i]);
          if (!val[i].courseinfo) continue;

          // //v3 fix
          const data = {};
          data._id = val[i].courseinfo._id;
          data.code = val[i].courseinfo.code;
          data.controls = val[i].courseinfo.controls;
          data.style = val[i].courseinfo.style;
          data.progress = val[i].progress;
          data.enroll = val[i].enroll;
          data.views = [];

          // if (val[i].complete == true && val[i].unenroll == false) {
          //   // this.completedCourse.push(val[i]);
          //   this.completedCourse.push(data);
          // } else {
          //   // this.inProgressCourse.push(val[i]);
          //   this.inProgressCourse.push(data);
          // }
        }
      }
    },
    userCourses(value) {
      console.log('watch call ---> userCourses', value);
      // this.enrollLists = value.enrolls; // แสดงการ์ดที่ in progress course ไว้
      // this.favoriteLists = value.favourite; // แสดงการ์ดที่ favourite ไว้
      this.enrollLists = value; // แสดงการ์ดที่ in progress course ไว้
    },
    getProfile(val) {
      let payload = {
        imageProfile: val.userinfo.image_profile,
        displayname: val.userinfo.displayname,
      };
      this.$store.commit('necessary/setUserinfo', payload);
    },
    getBanners(val) {
      this.bannerImage = val;
    },
  },
  created() {
    this.$store.commit('language/setChangingSidebar', false);
    this.$store.dispatch('fetchBanner');
    this.$store.dispatch('courses/fetchCourses');
    if (this.$store.getters['auth/userStatus']) {
      // this.$store.dispatch("courses/mfuREGEnroll");
      // this.$store.dispatch("auth/fetchCourseEducation");
      this.$store.dispatch('profile/getUserProfile');
    }
  },
  mounted() {
    //mfu
  },
  methods: {
    itemData(val) {
      this.selectedCourse = val;
    },
    bannerNav(navigation) {
      window.location.assign(navigation);
    },
    fetchPopularCourse() {
      this.popularCourse = this.$store.getters['courses/getPopCourses'];
      return this.popularCourse;
    },
    fetchNewCourse() {
      this.newCourse = this.$store.getters['courses/getNewCourses'];
      return this.newCourse;
    },
    fetchFreeCourse() {
      this.freeCourse = this.$store.getters['courses/getFreeCourses'];
      return this.freeCourse;
    },
    onClosePopUp() {
      this.popUpIsActive = false;
    },
  },
};
</script>

<style scoped>
.button-view-all {
  /* position: absolute; */
  color: white;
  border: 1px solid white;
  opacity: 0.7;
  width: 8rem;
  height: 3rem;
  margin: 1rem;
  transition: all 0.3s ease-out;
  border-radius: 30px;
}
.button-view-all:hover {
  opacity: 1;
  color: black;
  border-color: black;
  background-color: rgba(255, 255, 255, 0.75);
}
.imgContainer {
  cursor: pointer;
}
.mainBackground {
  background-blend-mode: darken;
  overflow: hidden;
  background-color: #000000;
  padding-top: 56px;
  /* Full height */
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.carousel.carousel-fade .carousel-item {
  /*opacity: 0;*/
  transition: opacity linear 0.6s;
}

.carousel-fade .carousel-item .imgContainer {
  max-height: auto;
  width: 100%;
}

.carousel-fade .carousel-item .imgContainer img {
  width: 100%;
  height: auto;
}

.indicatorStyle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

@media only screen and (max-width: 768px) {
  .carousel-fade .carousel-item .imgContainer {
    max-height: auto;
  }

  .carousel-fade .carousel-item .imgContainer img {
    width: 100%;
    height: auto;
  }
}
/*  */
.topictext {
  margin-left: 3rem;
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  font-family: Roboto;
  font-weight: bold;
}
.topiccourse {
  height: auto;
  margin-left: 3rem;
  display: flex;
  overflow: auto;
  overflow-y: hidden;
}
/* ------------------------------------------------------------ css Scrollbar ------------------------------------------------------------ */
::-webkit-scrollbar {
  width: 20px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px transparent;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: transparent;
}
/* ------------------------------------------------------------ css Scrollbar ------------------------------------------------------------ */
@media only screen and (min-width: 374px) {
  .mainBackground {
    min-height: 70vh;
  }
}
@media only screen and (min-width: 767px) {
  .mainBackground {
    min-height: 75vh;
  }
}
@media only screen and (min-width: 1023px) {
  .mainBackground {
    min-height: 87vh;
  }
}
</style>
